//COMPONENTS
import * as ComponentLibrary from "@picnicmedia/masanatemples123";

// Search bar component
export function SearchBar({ adAndBrandNames, paramsSetter, changeParams, clearInput, setClearInput, requestTableData }: any) {
  // Search bar has functionality to update url parameters in real-time
  const changeAdNameParams = (inputValue: string) => changeParams(inputValue, paramsSetter);
  return (
    <>
      <ComponentLibrary.PCSearchBar placeholder={`Search across ${paramsSetter === "adName" ? "ads" : "brands"}`} height={42} updateQueryParams={changeAdNameParams} clearInput={clearInput} setClearInput={setClearInput} requestTableData={requestTableData} currentQuery={adAndBrandNames} />
    </>
  );
}
